<template>
    <div class="webglContainer" style="overflow:hidden">
        <div id="webgl" ref="webgl"></div>
        <div v-if="!isDevices" class="rightBtns">
          <div class="btns">
            <!-- <div v-show="resInfos.switchs." class="btn fullBtn" @click="fullScreen()"></div> -->
            <div v-if="sceneInfos.vr == 1" class="btn vrBtn" @click="goVR()">
              <i></i>
            </div>
            <div v-if="sceneInfos.viewSwitch == 1" class="btn viewChangeBtn" @click="changeView()">
              <i></i>
            </div>
          </div>
        </div>
        <div v-if="isDevices" class="exitVrBtn" @click="exitVr()">
            退出VR模式
        </div>
        <div v-if="!isDevices" class="leftBottomBar">
          <div class="btns">
            <div :class="['btn', leftBtnActiveNum === 1?'active':'']" @click="playPano()">
              <img src="images/play.png" alt="" srcset="">
            </div>
            <div :class="['btn', listIsShow?'active':'']" @click="showList()">
              <img src="images/list.png" alt="" srcset="">
            </div>
            <div :class="['btn', leftBtnActiveNum === 3?'active':'']" @click="showPanoVR()">
              <img src="images/vr.png" alt="" srcset="">
            </div>
            <div :class="['btn', leftBtnActiveNum === 4?'active':'']" @click="showModel()">
              <img src="images/dollhouse.png" alt="" srcset="">
            </div>
            <div :class="['btn', leftBtnActiveNum === 5?'active':'']" @click="showModelTop()">
              <img src="images/top.png" alt="" srcset="">
            </div>
          </div>
        </div>
        <myPictureTip v-if="picTipShow" :closeFunc="closePicTip" :data="picData"></myPictureTip>
        <div v-if="listIsShow" class="thumbPicWrap" >
          <div class="scrollWrap">
            <el-scrollbar class="page-scroll">
              <div class="thumbPicList">
                <div v-for="(item, i) in resInfos.panos" :key="i" :class="[i===nowActivePano?'active':'']" @click="changePano(i)">
                  <img :src="item.physicalFile.thumbnailUrl" alt="" srcset="">
                  <span>{{item.physicalFile.fileName}}</span>
                </div>
              </div>
            </el-scrollbar>
          </div>
        </div>
    </div>
</template>

<script>
import * as THREE from 'three'
import { OrbitControls, MapControls } from 'three/examples/jsm/controls/OrbitControls'
import { TransformControls } from 'three/examples/jsm/controls/TransformControls'
import { DeviceOrientationControls } from 'three/examples/jsm/controls/DeviceOrientationControls'
import { StereoEffect } from 'three/examples/jsm/effects/StereoEffect'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader_z'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js'
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js'
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader.js'
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js'
import { TWEEN } from 'three/examples/jsm/libs/tween.module.min'
import zcfCommon from '../../public/com/zcf_common'
import https from '../https.js'
import myPictureTip from '../components/picture.vue'
let vm = null
const vertexShader = [
  'varying vec3 pPos;',
  'void main()',
  '{',
  '    pPos = position;',
  '    vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );',
  '    gl_Position = projectionMatrix * mvPosition;',
  '}'
].join('\n')

const fragmentShader = [
  '#ifdef GL_ES',
  '    precision highp float;',
  '#endif',
  'const float PI = 3.1415926;',
  'const float TWO_PI = 6.2831852;',

  'uniform samplerCube texture;',
  'uniform vec3 cPosition;',
  'varying vec3 pPos;',
  'void main()',
  '{',
  '    vec3 np = normalize(pPos-cPosition);',
  '    gl_FragColor = textureCube( texture, vec3(np.x,np.y,-np.z ));',
  '}'
].join('\n')
export default {
  components: {
    myPictureTip
  },
  data: () => {
    return {
      modelID: '',
      tipImgSrc: '',
      annie: [],
      aniMap: null,
      tipShow: false,
      canControl: false,
      loading: true,
      daping: null,
      video: null,
      resInfos: {},
      nowActivePano: 0,
      leftBtnActiveNum: 3,
      modelData: {},
      preMats: {},
      listIsShow: false,
      hotPointMaps: {},
      hPTypeArr: [],
      sceneInfos: {
        vr: 0,
        viewSwitch: 0
      },
      isEffect: false,
      isDevices: false,
      isChanged: false,
      picTipShow: false,
      picData: {}
    }
  },
  created () {
    this.sceneID = this.$route.query.id
    console.log(this.sceneID)
    vm = this
    https.fetchPost('/api/HotPoint/GetlistByPyFile_Scene_ID', {
      sceneID: this.sceneID
    }).then(res => {
      if(res.status === 200) {
        var m = {}
        m = res.data.scene
        m.model = res.data.model
        m.switchs = res.data.switchs
        m.panos = []
        for(var i = 0; i < res.data.result.length; i++) {
          var k = {}
          k.physicalFile = res.data.result[i].physicalFile
          k.hotPointlist = res.data.result[i].hotPointlist
          for(var key in res.data.result[i].physicalFile_Scene) {
            k[key] = res.data.result[i].physicalFile_Scene[key]
          }
          m.panos.push(k)
        }
        this.resInfos = m
        this.sceneInfos.vr = this.resInfos.switchs.vr
        this.sceneInfos.viewSwitch = this.resInfos.switchs.viewSwitch
        console.log(this.resInfos)
        console.log(this.sceneInfos)
        this.nowPanoName = this.resInfos.panos[0].physicalFile.fileName
        this.init()
      }
    })
  },
  mounted () {
    this.rafId = null
    this.container = null
    this.scene = null
    this.camera = null
    this.mesh = null
    this.renderer = null
    this.controls = null
    this.containerW = 0
    this.containerH = 0
    this.selectionBox = null
    this.transformControls = null
    this.mouse = new THREE.Vector2()
    this.raycaster = new THREE.Raycaster()
    this.onDownPosition = new THREE.Vector2()
    this.onUpPosition = new THREE.Vector2()
    this.pmremGenerator = null
    this.isDown = false
    this.isMoving = false
    this.isModelShow = false
    this.panoGroup = new THREE.Group()
    this.markGroup = new THREE.Group()
    this.fingers = null
    this.onPointerDownPointerX = 0
    this.onPointerDownPointerY = 0
    this.onPointerDownLon = 0
    this.onPointerDownLat = 0
    this.onPointerDownPointerX0 = 0
    this.onPointerDownPointerY0 = 0
    this.onPointerDownPointerX1 = 0
    this.onPointerDownPointerY1 = 0
    this.preMoveX = 0
    this.preMoveY = 0
    this.offX = 0
    this.offY = 0
    this.disFinger = 0
    this.lon = 270
    this.lat = 0
    this.phi = 0
    this.theta = 0
    this.canDamp = false
    this.dampingFactor = 0.2
    this.targetBox = null
    this.hasLoaded = false
    this.planeUniforms = null
    this.preV = new THREE.Vector2()
    this.nowPanoName = ''
    this.textrueLoader = new THREE.TextureLoader()
    this.clock = new THREE.Clock()
    this.planeMat = null
    this.mousePoint = null
    this.endPoint = null
    this.Devices = null
    this.effect = null
    this.hotTexture1 = null
  },
  methods: {
    changeMarkOpactiy(name, opacity, otherOpacity) {
      this.markGroup.traverse(child => {
        if(child.isMesh) {
          child.material.opacity = otherOpacity
          if(child.name === name) {
            child.material.opacity = opacity
          }
        }
      })
    },
    closePicTip() {
      this.picTipShow = false
    },
    exitVr() {
      this.isDevices = !this.isDevices
      if(window.orientation === 90 || window.orientation === -90) {
        this.isEffect = this.isDevices
      }else {
        this.isEffect = false
      }
    },
    goVR() {
      if(this.leftBtnActiveNum === 3) {
        this.listIsShow = false
        this.isDevices = !this.isDevices
        if(window.orientation === 90 || window.orientation === -90) {
          this.isEffect = this.isDevices
        }else {
          this.isEffect = false
        }
      }else{
        this.$message({
          message: '请在全景漫游模式下进入VR模式',
          type: 'warning'
        })
      }
    },
    changeView() {
    },
    //自动播放
    playPano() {
    },
    //显示图标
    showList() {
      this.listIsShow = !this.listIsShow
    },
    showPanoVR() {
      var nextPanoName = this.nowPanoName
      var cameraPos = this.panoGroup.getObjectByName(nextPanoName).position
      // this.endPoint.visible = false
      if(this.leftBtnActiveNum === 4) {
        this.modelToPano(cameraPos, nextPanoName)
      }else if(this.leftBtnActiveNum === 5) {
        this.modelTopToPano(cameraPos, nextPanoName)
      }
    },
    //全景到轴测图，顶视图到轴测图
    showModel() {
      var lat = -45
      var phi = THREE.Math.degToRad(90 - lat)
      var theta = THREE.Math.degToRad(this.lon)
      var cPos = new THREE.Vector3()
      if(this.leftBtnActiveNum === 3) {
        this.panoGroup.getObjectByName(this.nowPanoName).visible = false
        this.mesh.traverse((child) => {
          if(child.isMesh) {
            child.material = this.preMats[child.name]
            child.material.needsUpdate = true
          }
        })
        this.mesh.visible = true
        var cameraPos = this.panoGroup.getObjectByName(this.nowPanoName).position
        // this.endPoint.visible = true
        // this.endPoint.position.set(cameraPos.x, 0, cameraPos.z)
        this.changeMarkOpactiy(this.nowPanoName, 1, 0.5)

        var targetPos = cameraPos.clone()
        cPos.x = -10000 * Math.sin(phi) * Math.cos(theta) + cameraPos.x
        cPos.y = -10000 * Math.cos(phi) + cameraPos.y
        cPos.z = -10000 * Math.sin(phi) * Math.sin(theta) + cameraPos.z
        new TWEEN.Tween(this.camera.position)
          .to({ x: cPos.x, y: cPos.y, z: cPos.z }, 1000)
          .easing(TWEEN.Easing.Exponential.InOut)
          .start().onUpdate(() => {
            this.camera.updateProjectionMatrix()
          }).onComplete(() => {
            this.lat = -45
            this.leftBtnActiveNum = 4
            this.controls.target.copy(cameraPos)
            this.controls.enablePan = true
            this.controls.enableRotate = true
            this.controls.enableZoom = true
          })
        new TWEEN.Tween(this.targetBox.position)
          .to({ x: targetPos.x, y: targetPos.y, z: targetPos.z }, 1000)
          .easing(TWEEN.Easing.Exponential.InOut)
          .start().onUpdate(() => {
          }).onComplete(() => {

          })
      }else if(this.leftBtnActiveNum === 5) {
        cPos.x = -10000 * Math.sin(phi) * Math.cos(theta) + this.controls.target.x
        cPos.y = -10000 * Math.cos(phi) + this.controls.target.y
        cPos.z = -10000 * Math.sin(phi) * Math.sin(theta) + this.controls.target.z
        new TWEEN.Tween(this.camera.position)
          .to({ x: cPos.x, y: cPos.y, z: cPos.z }, 1000)
          .easing(TWEEN.Easing.Exponential.InOut)
          .start().onUpdate(() => {
            this.camera.updateProjectionMatrix()
          }).onComplete(() => {
            this.lat = -45
            this.leftBtnActiveNum = 4
            this.controls.enablePan = true
            this.controls.enableRotate = true
            this.controls.enableZoom = true
          })
      }
    },
    //全景到顶视图，轴测图到顶视图
    showModelTop() {
      var lat = -85
      var lon
      var cPos = new THREE.Vector3()
      if(this.leftBtnActiveNum === 3) {
        this.panoGroup.getObjectByName(this.nowPanoName).visible = false
        this.mesh.traverse((child) => {
          if(child.isMesh) {
            child.material = this.preMats[child.name]
            child.material.needsUpdate = true
          }
        })
        this.mesh.visible = true
        var cameraPos = this.panoGroup.getObjectByName(this.nowPanoName).position
        this.changeMarkOpactiy(this.nowPanoName, 1, 0.5)
        var targetPos = cameraPos.clone()
        lon = Math.abs(this.lon % 360) > 180 ? 270 : 90
        var phi = THREE.Math.degToRad(90 - lat)
        var theta = THREE.Math.degToRad(lon)
        cPos.x = -20000 * Math.sin(phi) * Math.cos(theta) + cameraPos.x
        cPos.y = -20000 * Math.cos(phi) + cameraPos.y
        cPos.z = -20000 * Math.sin(phi) * Math.sin(theta) + cameraPos.z
        new TWEEN.Tween(this.camera.position)
          .to({ x: cPos.x, y: cPos.y, z: cPos.z }, 1000)
          .easing(TWEEN.Easing.Exponential.InOut)
          .start().onUpdate(() => {
            this.camera.updateProjectionMatrix()
          }).onComplete(() => {
            var cPos1 = new THREE.Vector3()
            cPos1.x = -20000 * Math.sin(phi) * Math.cos(theta) + 0
            cPos1.y = -20000 * Math.cos(phi) + cameraPos.y
            cPos1.z = -20000 * Math.sin(phi) * Math.sin(theta) + 0
            new TWEEN.Tween(this.camera.position)
              .to({ x: cPos1.x, y: cPos1.y, z: cPos1.z }, 1000)
              .easing(TWEEN.Easing.Exponential.InOut)
              .start().onUpdate(() => {
                this.camera.updateProjectionMatrix()
              }).onComplete(() => {})

            new TWEEN.Tween(this.targetBox.position)
              .to({ x: 0, y: cameraPos.y, z: 0 }, 1000)
              .easing(TWEEN.Easing.Exponential.InOut)
              .start().onUpdate(() => {
              }).onComplete(() => {
                this.lat = -85
                this.lon = lon
                this.leftBtnActiveNum = 5
                this.controls.target.set(0, cameraPos.y, 0)
                this.controls.enablePan = true
                this.controls.enableRotate = false
                this.controls.enableZoom = true
              })
          })
        new TWEEN.Tween(this.targetBox.position)
          .to({ x: targetPos.x, y: targetPos.y, z: targetPos.z }, 1000)
          .easing(TWEEN.Easing.Exponential.InOut)
          .start().onUpdate(() => {
          }).onComplete(() => {

          })
      }else if(this.leftBtnActiveNum === 4) {
        var cTPos = new THREE.Vector3()
        cTPos = this.controls.target.clone()
        cTPos.sub(this.camera.position)
        var arr = this.seekAngle(cTPos.x, cTPos.y, cTPos.z)
        if(arr[0] < 0) {
          arr[0] += 360
        }
        lon = Math.abs(arr[0] % 360) >= 180 ? 270 : 90
        var phi1 = THREE.Math.degToRad(90 - lat)
        var theta1 = THREE.Math.degToRad(lon)
        cPos.x = -20000 * Math.sin(phi1) * Math.cos(theta1) + this.controls.target.x
        cPos.y = -20000 * Math.cos(phi1) + this.controls.target.y
        cPos.z = -20000 * Math.sin(phi1) * Math.sin(theta1) + this.controls.target.z
        new TWEEN.Tween(this.camera.position)
          .to({ x: cPos.x, y: cPos.y, z: cPos.z }, 1000)
          .easing(TWEEN.Easing.Exponential.InOut)
          .start().onUpdate(() => {
            this.camera.updateProjectionMatrix()
          }).onComplete(() => {
            var cPos1 = new THREE.Vector3()
            cPos1.x = -20000 * Math.sin(phi1) * Math.cos(theta1) + 0
            cPos1.y = -20000 * Math.cos(phi1) + this.controls.target.y
            cPos1.z = -20000 * Math.sin(phi1) * Math.sin(theta1) + 0
            new TWEEN.Tween(this.camera.position)
              .to({ x: cPos1.x, y: cPos1.y, z: cPos1.z }, 1000)
              .easing(TWEEN.Easing.Exponential.InOut)
              .start().onUpdate(() => {
                this.camera.updateProjectionMatrix()
              }).onComplete(() => {})

            new TWEEN.Tween(this.controls.target)
              .to({ x: 0, y: this.controls.target.y, z: 0 }, 1000)
              .easing(TWEEN.Easing.Exponential.InOut)
              .start().onUpdate(() => {
              }).onComplete(() => {
                this.lat = -85
                this.lon = lon
                this.leftBtnActiveNum = 5
                this.controls.enablePan = true
                this.controls.enableRotate = false
                this.controls.enableZoom = true
              })
          })
      }
    },
    //轴测图到全景图
    modelToPano(cameraPos, nextPanoName) {
      this.controls.enablePan = false
      this.controls.enableRotate = false
      this.controls.enableZoom = false
      this.leftBtnActiveNum = 3
      var cTPos = new THREE.Vector3()
      cTPos = this.controls.target.clone()
      cTPos.sub(this.camera.position)
      var arr = this.seekAngle(cTPos.x, cTPos.y, cTPos.z)
      var lat = 0
      var phi = THREE.Math.degToRad(90 - lat)
      var theta = THREE.Math.degToRad(arr[0])
      var tPos = new THREE.Vector3()
      tPos.x = 10000 * Math.sin(phi) * Math.cos(theta) + cameraPos.x
      tPos.y = 10000 * Math.cos(phi) + cameraPos.y
      tPos.z = 10000 * Math.sin(phi) * Math.sin(theta) + cameraPos.z
      console.log(tPos)
      new TWEEN.Tween(this.camera.position)
        .to({ x: cameraPos.x, y: cameraPos.y, z: cameraPos.z }, 1000)
        .easing(TWEEN.Easing.Exponential.InOut)
        .start().onUpdate(() => {
          this.camera.updateProjectionMatrix()
        }).onComplete(() => {
        })
      new TWEEN.Tween(this.targetBox.position)
        .to({ x: tPos.x, y: tPos.y, z: tPos.z }, 1000)
        .easing(TWEEN.Easing.Exponential.InOut)
        .start().onUpdate(() => {
        }).onComplete(() => {
          this.lat = 0
          this.lon = arr[0]
          console.log(this.lon, this.lat)
          this.nowPanoName = nextPanoName
          this.planeUniforms.texture.value = this.panoGroup.getObjectByName(this.nowPanoName).material.uniforms.texture.value
          this.planeUniforms.cPosition.value = this.camera.position.clone()
          this.mesh.traverse((child) => {
            if(child.isMesh) {
              this.preMats[child.name] = child.material
              child.material = this.planeMat
              child.material.needsUpdate = true
            }
          })
          this.panoGroup.getObjectByName(this.nowPanoName).visible = true
          // this.controls.target.copy(cameraPos)
          this.mesh.visible = false
          this.isModelShow = false
        })
    },
    //顶视图到全景图
    modelTopToPano(cameraPos, nextPanoName) {
      this.controls.enablePan = false
      this.controls.enableRotate = false
      this.controls.enableZoom = false
      this.leftBtnActiveNum = 3
      var cTPos1 = new THREE.Vector3()
      var lat1 = this.lat
      var lon1 = this.lon
      var phi1 = THREE.Math.degToRad(90 - lat1)
      var theta1 = THREE.Math.degToRad(lon1)
      cTPos1.x = -20000 * Math.sin(phi1) * Math.cos(theta1) + cameraPos.x
      cTPos1.y = -20000 * Math.cos(phi1) + cameraPos.y
      cTPos1.z = -20000 * Math.sin(phi1) * Math.sin(theta1) + cameraPos.z
      console.log(cTPos1)
      new TWEEN.Tween(this.camera.position)
        .to({ x: cTPos1.x, y: cTPos1.y, z: cTPos1.z }, 1000)
        .easing(TWEEN.Easing.Exponential.InOut)
        .start().onUpdate(() => {
          this.camera.updateProjectionMatrix()
        }).onComplete(() => {
          var lat2 = 0
          var lon2 = this.lon
          var phi2 = THREE.Math.degToRad(90 - lat2)
          var theta2 = THREE.Math.degToRad(lon2)
          var cTPos2 = new THREE.Vector3()
          cTPos2.x = 10000 * Math.sin(phi2) * Math.cos(theta2) + cameraPos.x
          cTPos2.y = 10000 * Math.cos(phi2) + cameraPos.y
          cTPos2.z = 10000 * Math.sin(phi2) * Math.sin(theta2) + cameraPos.z
          new TWEEN.Tween(this.camera.position)
            .to({ x: cameraPos.x, y: cameraPos.y, z: cameraPos.z }, 1000)
            .easing(TWEEN.Easing.Exponential.InOut)
            .start().onUpdate(() => {
              this.camera.updateProjectionMatrix()
            }).onComplete(() => {
              this.lat = 0
              this.nowPanoName = nextPanoName
              console.log(this.nowPanoName)
              this.mesh.visible = false
              this.planeUniforms.texture.value = this.panoGroup.getObjectByName(this.nowPanoName).material.uniforms.texture.value
              this.planeUniforms.cPosition.value = this.camera.position.clone()
              this.mesh.traverse((child) => {
                if(child.isMesh) {
                  this.preMats[child.name] = child.material
                  child.material = this.planeMat
                  child.material.needsUpdate = true
                }
              })
              this.panoGroup.getObjectByName(this.nowPanoName).visible = true
              this.isModelShow = false
            })
          new TWEEN.Tween(this.targetBox.position)
            .to({ x: cTPos2.x, y: cTPos2.y, z: cTPos2.z }, 1000)
            .easing(TWEEN.Easing.Exponential.InOut)
            .start().onUpdate(() => {
            }).onComplete(() => {})
        })
      new TWEEN.Tween(this.targetBox.position)
        .to({ x: cameraPos.x, y: cameraPos.y, z: cameraPos.z }, 1000)
        .easing(TWEEN.Easing.Exponential.InOut)
        .start().onUpdate(() => {
        }).onComplete(() => {})
    },
    //全景图到全景图
    panoToPano(cameraPos, nextPanoName) {
      if(nextPanoName !== this.nowPanoName) {
        this.panoGroup.getObjectByName(this.nowPanoName).visible = false
        this.planeUniforms.texture.value = this.panoGroup.getObjectByName(this.nowPanoName).material.uniforms.texture.value
        this.planeUniforms.cPosition.value = this.camera.position.clone()
        this.isModelShow = true
        this.mesh.visible = true
        var pos1 = this.targetBox.position.clone()
        var pos2 = this.camera.position.clone()
        var pos3 = pos1.sub(pos2)
        var targetPos = cameraPos.clone()
        targetPos.add(pos3)
        new TWEEN.Tween(this.camera.position)
          .to({ x: cameraPos.x, y: cameraPos.y, z: cameraPos.z }, 1000)
          .easing(TWEEN.Easing.Exponential.InOut)
          .start().onUpdate(() => {
          }).onComplete(() => {
            this.nowPanoName = nextPanoName
            console.log(this.nowPanoName)
            this.mesh.visible = false
            this.panoGroup.getObjectByName(this.nowPanoName).visible = true
            this.posObj(this.targetBox, this.camera, 1, this.lon, this.lat, 0)
            this.isModelShow = false
          })
      }
    },
    //切换全景图
    changePano(num) {
      this.nowActivePano = num
      var nextPanoName = this.resInfos.panos[num].physicalFile.fileName
      var cameraPos = this.panoGroup.getObjectByName(nextPanoName).position
      if(this.leftBtnActiveNum === 3) {
        this.panoToPano(cameraPos, nextPanoName)
      }else if(this.leftBtnActiveNum === 4) {
        this.modelToPano(cameraPos, nextPanoName)
      }else if(this.leftBtnActiveNum === 5) {
        this.modelTopToPano(cameraPos, nextPanoName)
      }
    },
    closeTip() {
      this.tipImgSrc = ''
      this.tipShow = false
    },
    getHotPointInfosByID(id) {
      var arr = this.resInfos.panos[this.nowActivePano].hotPointlist.filter(item => {
        return item.hotPoint.id === id
      })
      return arr
    },
    // 场景初始
    init () {
      this.container = this.$refs.webgl
      this.containerW = this.$refs.webgl.getBoundingClientRect().width
      this.containerH = this.$refs.webgl.getBoundingClientRect().height
      this.scene = new THREE.Scene()
      this.targetBox = new THREE.Mesh(
        new THREE.BoxBufferGeometry(1, 1, 1),
        new THREE.MeshBasicMaterial({
          color: 0xff0000,
          transparent: true,
          opacity: 0
        })
      )
      this.scene.add(this.targetBox)
      this.scene.add(this.panoGroup)
      this.scene.add(this.markGroup)

      // this.aniMap = new THREE.TextureLoader().load('http://720.tour3c.com/imgs/details/Hotspot7_gif.png')
      // var textureAnimator = new this.TextureAnimator(this.aniMap, 1, 25, 25, 75)
      // this.annie.push(textureAnimator)
      this.camera = new THREE.PerspectiveCamera(
        70,
        this.containerW / this.containerH,
        10,
        999999
      )

      this.camera.position.set(this.resInfos.panos[0].posX, this.resInfos.panos[0].posY, this.resInfos.panos[0].posZ)
      // this.camera.position.set(0, this.panos[0].pos.y, 0)
      this.posObj(this.targetBox, this.camera, 10000, this.lon, this.lat, 0)
      this.camera.lookAt(this.targetBox.position)
      this.scene.add(this.camera)

      const ambientLight = new THREE.AmbientLight(0x888888)
      this.scene.add(ambientLight)

      const directionalLight = new THREE.DirectionalLight(0xffffff, 1.2)
      directionalLight.position.set(100, 100, 100)
      this.scene.add(directionalLight)

      const directionalLight01 = new THREE.DirectionalLight(0xffffff, 0.8)
      directionalLight01.position.set(-100, 0, -100)
      this.scene.add(directionalLight01)

      //鼠标指针
      var textureLoader = new THREE.TextureLoader()
      var hotTexture = textureLoader.load('images/mouseIcon.png')
      var hotMat = new THREE.MeshBasicMaterial({
        map: hotTexture,
        color: 0xffffff,
        transparent: true,
        side: THREE.DoubleSide,
        depthTest: false
      })

      this.mousePoint = new THREE.Mesh(
        new THREE.PlaneGeometry(500, 500),
        hotMat
      )
      this.scene.add(this.mousePoint)
      this.mousePoint.visible = false


      this.hotTexture1 = textureLoader.load('images/End.png')
      // var hotMa1 = new THREE.MeshBasicMaterial({
      //   map: this.hotTexture1,
      //   color: 0xffffff,
      //   transparent: true,
      //   side: THREE.DoubleSide
      // })

      // this.endPoint = new THREE.Mesh(
      //   new THREE.PlaneGeometry(500, 500),
      //   hotMa1
      // )
      // this.endPoint.rotation.x = -Math.PI / 2
      // this.scene.add(this.endPoint)
      // this.endPoint.visible = false

      this.planeUniforms = {
        cPosition: { value: new THREE.Vector3() },
        texture: { value: null },
        ...THREE.UniformsLib.lights
      }
      this.planeMat = new THREE.ShaderMaterial({
        uniforms: this.planeUniforms,
        vertexShader: vertexShader,
        fragmentShader: fragmentShader,
        lights: true
      })
      this.planeMat.needsUpdate = true

      for (let i = 0; i < this.resInfos.panos.length; i++) {
        this.generatePano(this.panoGroup, this.resInfos.panos[i])
        this.generateMark(this.markGroup, this.resInfos.panos[i])
      }
      console.log(this.panoGroup)
      const modelLoader = new GLTFLoader()
      var dracoLoader = new DRACOLoader()
      dracoLoader.setDecoderPath('com/draco/gltf/')
      modelLoader.setDRACOLoader(dracoLoader)
      modelLoader.setPath(this.resInfos.model.path + '/')
      modelLoader.load('model.gltf', gltf => {
        this.mesh = gltf.scene
        this.loading = false
        this.planeUniforms.texture.value = this.panoGroup.getObjectByName(this.nowPanoName).material.uniforms.texture.value
        this.planeUniforms.cPosition.value = this.camera.position.clone()
        this.mesh.traverse((child) => {
          if(child.isMesh) {
            this.preMats[child.name] = child.material
            child.material = this.planeMat
            child.material.needsUpdate = true
          }
        })
        this.mesh.visible = false
        this.scene.add(this.mesh)
        this.hasLoaded = true
        this.loading = false
        this.canControl = true
        this.modelData = zcfCommon.getModelDate(this.mesh, THREE)
        this.controls.minDistance = this.modelData.r * 0.1
        this.controls.maxDistance = this.modelData.r * 0.5
        this.animate()
      })
      this.renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true
      })
      this.renderer.setPixelRatio(window.devicePixelRatio)
      this.renderer.setSize(this.containerW, this.containerH)

      this.container.appendChild(this.renderer.domElement)

      this.controls = new MapControls(this.camera, this.renderer.domElement)

      this.controls.enableDamping = true // an animation loop is required when either damping or auto-rotation are enabled
      this.controls.dampingFactor = 0.05

      this.controls.screenSpacePanning = false

      this.controls.maxPolarAngle = Math.PI / 2

      this.controls.enableRotate = false
      this.controls.enableZoom = false
      this.controls.enablePan = false

      this.Devices = new DeviceOrientationControls(this.camera)
      this.Devices.connect()

      this.effect = new StereoEffect(this.renderer)
      this.effect.setSize(window.innerWidth, window.innerHeight)


      window.addEventListener('resize', this.onresize, false)
      this.renderer.domElement.addEventListener('mousedown', this.onRendererMouseDown, false)
      this.renderer.domElement.addEventListener('mousemove', this.onRendererMouseMove, false)
      this.renderer.domElement.addEventListener('mouseup', this.onRendererMouseUp, false)
      this.renderer.domElement.addEventListener('touchstart', this.onRendererTouchStart, false)
      this.renderer.domElement.addEventListener('touchmove', this.onRendererTouchMove, false)
      this.renderer.domElement.addEventListener('touchend', this.onRendererTouchEnd, false)
    },
    getMinPoint(arr, pos) {
      var name = ''
      var dis = Infinity
      for (var i = 0; i < arr.length; i++) {
        var nextPos = new THREE.Vector3(arr[i].posX, 0, arr[i].posZ)
        var nowDis = pos.distanceTo(nextPos)
        // console.log(pos);
        // console.log(nextPos);
        // console.log(nowDis);
        if(nowDis < dis) {
          dis = nowDis
          name = arr[i].physicalFile.fileName
        }
      }
      return name
    },
    onRendererTouchStart(event) {
      event.preventDefault()
      this.isMoving = false
      this.isDown = true
      this.canDamp = false
      this.preV.x = event.touches[0].pageX
      this.preV.y = event.touches[0].pageY
      if (event.touches.length === 1) {
        this.fingers = 1
        this.preMoveX = this.onPointerDownPointerX = event.touches[0].pageX
        this.preMoveY = this.onPointerDownPointerY = event.touches[0].pageY
        this.onPointerDownLon = this.lon
        this.onPointerDownLat = this.lat
      }else if(event.touches.length === 2) {
        this.fingers = 2
        this.onPointerDownPointerX0 = event.touches[0].pageX
        this.onPointerDownPointerY0 = event.touches[0].pageY
        this.onPointerDownPointerX1 = event.touches[1].pageX
        this.onPointerDownPointerY1 = event.touches[1].pageY
        this.disFinger = Math.sqrt(Math.pow((this.onPointerDownPointerX1 - this.onPointerDownPointerX0), 2) + Math.pow((this.onPointerDownPointerY1 - this.onPointerDownPointerY0), 2))
      }
    },
    onRendererTouchMove(event) {
      event.preventDefault()
      if(this.canControl) {
        this.isMoving = true
        if (event.touches.length === 1 && this.fingers === 1) {
          this.lon = (this.onPointerDownPointerX - event.touches[0].pageX) * 0.3 + this.onPointerDownLon
          this.lat = (event.touches[0].pageY - this.onPointerDownPointerY) * 0.3 + this.onPointerDownLat
          this.posObj(this.targetBox, this.camera, 1, this.lon, this.lat, 0)
          this.offX = event.touches[0].pageX - this.preMoveX
          this.offY = event.touches[0].pageY - this.preMoveY
          this.preMoveX = event.touches[0].pageX
          this.preMoveY = event.touches[0].pageY
        }else if(event.touches.length === 2 && this.fingers === 2) {
          event.preventDefault()
          this.onPointerDownPointerX0 = event.touches[0].pageX
          this.onPointerDownPointerY0 = event.touches[0].pageY
          this.onPointerDownPointerX1 = event.touches[1].pageX
          this.onPointerDownPointerY1 = event.touches[1].pageY
          var disFingerNow = Math.sqrt(Math.pow((this.onPointerDownPointerX1 - this.onPointerDownPointerX0), 2) + Math.pow((this.onPointerDownPointerY1 - this.onPointerDownPointerY0), 2))
          var ratio = (disFingerNow - this.disFinger) / this.disFinger
          if(ratio < 0) {
            if(this.camera.fov <= 60) {
              this.camera.fov = (1 - ratio) * this.cameraFov
              this.camera.updateProjectionMatrix()
            }
          }else {
            if(this.camera.fov >= 20) {
              this.camera.fov = (1 - ratio * 0.15) * this.cameraFov
              this.camera.updateProjectionMatrix()
            }
          }
        }
      }
    },
    onRendererTouchEnd(event) {
      var upV = new THREE.Vector2(event.changedTouches[0].clientX, event.changedTouches[0].clientY)
      var dis = this.preV.distanceTo(upV)
      var nextPanoName
      var cameraPos
      if(this.canControl) {
        if(this.fingers === 1) {
          this.canDamp = true
        }
        this.fingers = 0
        this.cameraFov = this.camera.fov
        if(dis < 1) {
          this.mouse.x = ((event.changedTouches[0].clientX - window.innerWidth) / window.innerWidth) * 2 + 1
          this.mouse.y = -((event.changedTouches[0].clientY - window.innerHeight) / window.innerHeight) * 2 - 1
          this.raycaster.setFromCamera(this.mouse, this.camera)
          var intersectionsHotPoint = this.raycaster.intersectObjects(this.panoGroup.children, true)
          if(intersectionsHotPoint.length > 0) {
            if(intersectionsHotPoint[0].object.hotType) {
              switch(intersectionsHotPoint[0].object.hotType) {
                case 0:
                  break
                case 1: //全景切换
                  break
                case 2: //超链接
                  window.location.href = intersectionsHotPoint[0].object.hotContext
                  break
                case 3: //图片
                case 4: //视频
                  var arr = this.getHotPointInfosByID(intersectionsHotPoint[0].object.name)
                  this.picTipShow = true
                  this.picData = arr[0]
                  break
                default:
                  break
              }
            }else{
              var intersections = this.raycaster.intersectObjects(this.mesh.children, true)
              if(intersections.length > 0) {
                nextPanoName = this.getMinPoint(this.resInfos.panos, intersections[0].point)
                cameraPos = this.panoGroup.getObjectByName(nextPanoName).position
                if(this.leftBtnActiveNum === 4) {
                  this.modelToPano(cameraPos, nextPanoName)
                }else if(this.leftBtnActiveNum === 5) {
                  this.modelTopToPano(cameraPos, nextPanoName)
                }else {
                  this.panoToPano(cameraPos, nextPanoName)
                }
                this.changeMarkOpactiy(nextPanoName, 0, 0.5)
              }
            }
          }else{

          }
        }
        this.isMoving = false
      }
    },
    onRendererMouseDown(event) {
      event.preventDefault()
      this.isMoving = false
      this.isDown = true
      this.canDamp = false
      this.preV.x = event.clientX
      this.preV.y = event.clientY
      this.preMoveX = this.onPointerDownPointerX = event.clientX
      this.preMoveY = this.onPointerDownPointerY = event.clientY
      this.onPointerDownLon = this.lon
      this.onPointerDownLat = this.lat
    },
    onRendererMouseMove(event) {
      event.preventDefault()
      this.isMoving = true
      if(this.isDown) {
        if(this.leftBtnActiveNum !== 4 && this.leftBtnActiveNum !== 5) {
          this.lon = (this.onPointerDownPointerX - event.clientX) * 0.15 + this.onPointerDownLon
          this.lat = (event.clientY - this.onPointerDownPointerY) * 0.15 + this.onPointerDownLat
          this.posObj(this.targetBox, this.camera, 1, this.lon, this.lat, 0)
          this.offX = event.clientX - this.preMoveX
          this.offY = event.clientY - this.preMoveY
          this.preMoveX = event.clientX
          this.preMoveY = event.clientY
        }
      }else{
        if(this.hasLoaded) {
          this.mouse.x = ((event.clientX - window.innerWidth) / window.innerWidth) * 2 + 1
          this.mouse.y = -((event.clientY - window.innerHeight) / window.innerHeight) * 2 - 1
          this.raycaster.setFromCamera(this.mouse, this.camera)
          var intersections = this.raycaster.intersectObjects(this.mesh.children, true)
          if(intersections.length > 0) {
            var nV3 = intersections[0].face.normal.clone()
            var pV3 = intersections[0].point.clone()
            pV3.add(nV3.multiplyScalar(10.0))
            this.mousePoint.visible = true
            this.mousePoint.position.set(0, 0, 0)
            this.mousePoint.lookAt(nV3)
            this.mousePoint.position.copy(pV3)
          }else{
            this.mousePoint.visible = false
          }
        }
      }
    },
    onRendererMouseUp() {
      var upV = new THREE.Vector2(event.clientX, event.clientY)
      var dis = this.preV.distanceTo(upV)
      var cameraPos
      var nextPanoName
      if(this.canControl) {
        if(dis < 1) {
          this.mouse.x = ((event.clientX - window.innerWidth) / window.innerWidth) * 2 + 1
          this.mouse.y = -((event.clientY - window.innerHeight) / window.innerHeight) * 2 - 1
          this.raycaster.setFromCamera(this.mouse, this.camera)
          // var intersections = this.raycaster.intersectObjects(this.scene.children, true)
          // if(intersections.length > 0) {
          //   console.log(intersections[0])
          //   console.log(intersections[0].point)
          //   nextPanoName = this.getMinPoint(this.resInfos.panos, intersections[0].point)
          //   console.log(nextPanoName)
          //   cameraPos = this.panoGroup.getObjectByName(nextPanoName).position
          //   console.log(cameraPos)
          //   if(this.leftBtnActiveNum === 4) {
          //     this.modelToPano(cameraPos, nextPanoName)
          //   }else if(this.leftBtnActiveNum === 5) {
          //     this.modelTopToPano(cameraPos, nextPanoName)
          //   }else {
          //     this.panoToPano(cameraPos, nextPanoName)
          //   }
          // }
          var intersectionsHotPoint = this.raycaster.intersectObjects(this.panoGroup.children, true)
          if(intersectionsHotPoint.length > 0) {
            if(intersectionsHotPoint[0].object.hotType) {
              switch(intersectionsHotPoint[0].object.hotType) {
                case 0:
                  break
                case 1: //全景切换
                  break
                case 2: //超链接
                  window.location.href = intersectionsHotPoint[0].object.hotContext
                  break
                case 3: //图片
                case 4: //视频
                  var arr = this.getHotPointInfosByID(intersectionsHotPoint[0].object.name)
                  this.picTipShow = true
                  this.picData = arr[0]
                  break
                default:
                  break
              }
            }else{
              var intersections = this.raycaster.intersectObjects(this.mesh.children, true)
              if(intersections.length > 0) {
                nextPanoName = this.getMinPoint(this.resInfos.panos, intersections[0].point)
                cameraPos = this.panoGroup.getObjectByName(nextPanoName).position
                if(this.leftBtnActiveNum === 4) {
                  this.modelToPano(cameraPos, nextPanoName)
                }else if(this.leftBtnActiveNum === 5) {
                  this.modelTopToPano(cameraPos, nextPanoName)
                }else {
                  this.panoToPano(cameraPos, nextPanoName)
                }
                this.changeMarkOpactiy(nextPanoName, 0, 0.5)
              }
            }
          }else{

          }
        }
      }
      this.isMoving = false
      this.isDown = false
    },
    generatePano(panoGroup, data) {
      var r = data.physicalFile.filePath
      var urls = [
        r + '/l1_r_1_1.jpg',
        r + '/l1_l_1_1.jpg',
        r + '/l1_u_1_1.jpg',
        r + '/l1_d_1_1.jpg',
        r + '/l1_f_1_1.jpg',
        r + '/l1_b_1_1.jpg'
      ]

      var textureCube = new THREE.CubeTextureLoader().load(urls)
      textureCube.format = THREE.RGBFormat
      textureCube.mapping = THREE.CubeRefractionMapping
      console.log(textureCube)
      var planeUniforms = {
        cPosition: { value: new THREE.Vector3(0, 0, 0) },
        texture: { value: textureCube },
        ...THREE.UniformsLib.lights
      }
      var cubeMat = new THREE.ShaderMaterial({
        uniforms: planeUniforms,
        vertexShader: vertexShader,
        fragmentShader: fragmentShader,
        lights: true
      })
      cubeMat.needsUpdate = true

      var geometry = new THREE.BoxBufferGeometry(5000, 5000, 5000)
      // var geometry = new THREE.SphereBufferGeometry(90000, 32, 32)
      geometry.scale(1, 1, -1)
      var cubeMesh = new THREE.Mesh(geometry, cubeMat)
      cubeMesh.position.set(data.posX, data.posY, data.posZ)
      cubeMesh.visible = false
      cubeMesh.name = data.physicalFile.fileName
      if(cubeMesh.name === this.nowPanoName) {
        cubeMesh.visible = true
      }
      panoGroup.add(cubeMesh)

      for(let i = 0; i < data.hotPointlist.length; i++) {
        var hotPointURL = data.hotPointlist[i].hotPoint.hotPointURL
        console.log(hotPointURL)
        if(this.hPTypeArr.indexOf(hotPointURL) === -1) {
          this.hotPointMaps[hotPointURL] = new THREE.TextureLoader().load('imgs/points/gif' + hotPointURL + '.png')
          var textureAnimator = new this.TextureAnimator(this.hotPointMaps[hotPointURL], 1, 25, 25, 75)
          this.hPTypeArr.push(hotPointURL)
          this.annie.push(textureAnimator)
        }
        var material = new THREE.SpriteMaterial({ map: this.hotPointMaps[hotPointURL], color: 0xffffff, fog: true })
        var sprite = new THREE.Sprite(material)
        sprite.name = data.hotPointlist[i].hotPoint.id
        sprite.hotType = data.hotPointlist[i].hotPoint.hotType
        sprite.hotContext = data.hotPointlist[i].hotPoint.hotContext
        sprite.position.set(data.hotPointlist[i].hotPoint.posX, data.hotPointlist[i].hotPoint.posY, data.hotPointlist[i].hotPoint.posZ)
        sprite.scale.set(200, 200, 1)
        sprite.renderOrder = 10
        cubeMesh.add(sprite)
        var sprite1 = this.makeTextSprite(data.hotPointlist[i].hotPoint.hotTitle)
        sprite1.name = data.hotPointlist[i].hotPoint.id
        sprite1.hotType = data.hotPointlist[i].hotPoint.hotType
        sprite1.hotContext = data.hotPointlist[i].hotPoint.hotContext
        var array = this.seekAngle(sprite.position.x, sprite.position.y, sprite.position.z)
        var latS = Math.max(-80, Math.min(80, array[1] + 3))
        var phiS = THREE.Math.degToRad(90 - latS)
        var thetaS = THREE.Math.degToRad(array[0])

        sprite1.position.x = (500 + 100) * Math.sin(phiS) * Math.cos(thetaS)
        sprite1.position.y = (500 + 100) * Math.cos(phiS)
        sprite1.position.z = (500 + 100) * Math.sin(phiS) * Math.sin(thetaS)
        sprite1.renderOrder = 10
        cubeMesh.add(sprite1)
      }
    },
    generateMark(markGroup, data) {
      var hotMa1 = new THREE.MeshBasicMaterial({
        map: this.hotTexture1,
        color: 0xffffff,
        transparent: true,
        side: THREE.DoubleSide,
        opacity: 0.5,
        depthTest: false
      })

      var markPoint = new THREE.Mesh(
        new THREE.PlaneGeometry(500, 500),
        hotMa1
      )
      markPoint.name = data.physicalFile.fileName
      if(markPoint.name === this.nowPanoName) {
        markPoint.material.opacity = 0
      }
      markPoint.rotation.x = -Math.PI / 2
      markPoint.position.set(data.posX, 10, data.posZ)
      markGroup.add(markPoint)
    },
    posObj(obj, cam, r, lon, lat, h) {
      lat = Math.max(-85, Math.min(85, lat))
      var phi = THREE.Math.degToRad(90 - lat)
      var theta = THREE.Math.degToRad(lon)
      obj.position.x = r * Math.sin(phi) * Math.cos(theta) + cam.position.x
      obj.position.y = r * Math.cos(phi) + cam.position.y
      obj.position.z = r * Math.sin(phi) * Math.sin(theta) + cam.position.z
    },
    // 窗口改变
    onresize () {
      this.containerW = this.$refs.webgl.getBoundingClientRect().width
      this.containerH = this.$refs.webgl.getBoundingClientRect().height
      this.camera.aspect = this.containerW / this.containerH
      this.camera.updateProjectionMatrix()
      this.renderer.setSize(this.containerW, this.containerH)
      this.effect.setSize(this.containerW, this.containerH)
      if(window.orientation === 90 || window.orientation === -90) {
        this.isEffect = this.isDevices
      }else {
        this.isEffect = false
      }
    },
    // 循环渲染
    render() {
      if(this.isDevices && this.isEffect) {
        this.effect.render(this.scene, this.camera)
        if(!this.isChanged) {
          this.effect.setSize(window.innerWidth, window.innerHeight)
          this.isChanged = true
        }
      }else{
        this.renderer.render(this.scene, this.camera)
        if(this.isChanged) {
          this.renderer.setSize(window.innerWidth, window.innerHeight)
          this.isChanged = false
        }
      }
    },
    animate () {
      var delta = this.clock.getDelta()
      TWEEN.update()
      if(!this.isModelShow) {
        if(!this.isDevices) {
          if(this.canDamp) {
            this.offX *= (1 - this.dampingFactor)
            this.offY *= (1 - this.dampingFactor)
            if(Math.abs(this.offX) <= 0.01) {
              this.offX = 0
            }
            if(Math.abs(this.offY) <= 0.01) {
              this.offY = 0
            }
            if(this.offX === 0 && this.offX === 0) {
              this.canDamp = false
            }
            this.lon -= this.offX
            if(this.lat <= 85) {
              this.lat += this.offY
            }
            this.posObj(this.targetBox, this.camera, 1, this.lon, this.lat, 0)
          }
          this.camera.lookAt(this.targetBox.position)
        }else{
          this.Devices.update()
        }
      }
      if(this.leftBtnActiveNum === 4 || this.leftBtnActiveNum === 5) {
        this.controls.update()
        this.targetBox.position.copy(this.controls.target)
      }

      this.rafId = requestAnimationFrame(this.animate)
      if(this.annie) {
        for(var i = 0; i < this.annie.length; i++) {
          this.annie[i].update(2000 * delta)
        }
      }
      this.render()
    },
    initHotPoint(arr, group) {
      var length = arr.length
      for(var i = 0; i < length; i++) {
        this.createHotPoint(arr[i], group)
      }
    },
    createHotPoint(arr, group) {
      // if(hPTypeArr.indexOf(arr.hPType) == -1) {
      //   hotPointMaps[arr.hPType] = textureLoader.load(arr.HotPointURL)
      //   var textureAnimator = new TextureAnimator(hotPointMaps[arr.hPType], 1, 25, 25, 75)
      //   hPTypeArr.push(arr.hPType)
      //   annie.push(textureAnimator)
      // }
      // var material = new THREE.SpriteMaterial({ map: hotPointMaps[arr.hPType], color: 0xffffff, fog: true })
      // var sprite = new THREE.Sprite(material)
      // sprite.name = arr.id
      // sprite.position.set(arr.posX, arr.posY, arr.posZ)
      // sprite.scale.set(40, 40, 1)
      // group.add(sprite)

      // var sprite1 = this.makeTextSprite(arr.info)
      // sprite1.name = arr.id
      // var array = this.seekAngle(sprite.position.x, sprite.position.y, sprite.position.z)
      // var latS = Math.max(-80, Math.min(80, array[1] + 2))
      // var phiS = THREE.Math.degToRad(90 - latS)
      // var thetaS = THREE.Math.degToRad(array[0])

      // sprite1.position.x = (cameraR + 100) * Math.sin(phiS) * Math.cos(thetaS)
      // sprite1.position.y = (cameraR + 100) * Math.cos(phiS)
      // sprite1.position.z = (cameraR + 100) * Math.sin(phiS) * Math.sin(thetaS)
      // group.add(sprite1)
    },
    makeTextSprite(message) {
      var fontsize = 24

      var borderThickness = 1

      var borderColor = { r: 0, g: 0, b: 0, a: 0 }

      var backgroundColor = { r: 255, g: 255, b: 255, a: 0.5 }


      var canvas = document.createElement('canvas')
      var context = canvas.getContext('2d')
      context.font = 'italic small-caps bold 24px Heiti '

      var metrics = context.measureText(message)
      var textWidth = metrics.width
      canvas.width = (textWidth + 40) * 2
      canvas.height = (fontsize * 1.4) * 2
      context.fillStyle = 'rgba(' + backgroundColor.r + ',' + backgroundColor.g + ',' +
            backgroundColor.b + ',' + backgroundColor.a + ')'
      context.strokeStyle = 'rgba(' + borderColor.r + ',' + borderColor.g + ',' +
            borderColor.b + ',' + borderColor.a + ')'

      context.lineWidth = borderThickness
      this.roundRect(context, 0, 0, canvas.width, canvas.height, 2)
      context.fillStyle = 'rgba(0, 0, 0, 1.0)'
      context.font = 'small-caps 48px Heiti '
      context.fillText(message, 40, fontsize * 2.2)
      var texture = new THREE.Texture(canvas)
      texture.format = THREE.RGBAFormat
      texture.needsUpdate = true
      var spriteMaterial = new THREE.SpriteMaterial(
        { map: texture, transparent: true })
      var sprite = new THREE.Sprite(spriteMaterial)
      sprite.scale.set(canvas.width * 0.3, canvas.height * 0.3, 1.0)
      return sprite
    },
    roundRect(ctx, x, y, w, h) {
      ctx.beginPath()
      ctx.moveTo(x, y)
      ctx.lineTo(x + w, y)
      ctx.lineTo(x + w, y + h)
      ctx.lineTo(x, y + h)
      ctx.lineTo(x, y)
      ctx.closePath()
      ctx.fill()
      ctx.stroke()
    },
    seekAngle(x, y, z) {
      var r = Math.sqrt(x * x + y * y + z * z)
      var phi = Math.acos(y / r)
      var theta = Math.atan(z / x)
      var lon
      if(x >= 0) {
        lon = theta * 180 / Math.PI
      }else {
        lon = 180 + theta * 180 / Math.PI
      }

      var lat = 90 - phi * 180 / Math.PI
      return [lon, lat]
    },
    TextureAnimator(texture, tilesHoriz, tilesVert, numTiles, tileDispDuration) {
      this.tilesHorizontal = tilesHoriz
      this.tilesVertical = tilesVert
      this.numberOfTiles = numTiles
      texture.wrapS = texture.wrapT = THREE.RepeatWrapping
      texture.repeat.set(1 / this.tilesHorizontal, 1 / this.tilesVertical)

      this.tileDisplayDuration = tileDispDuration

      this.currentDisplayTime = 0

      this.currentTile = 25

      this.update = function (milliSec) {
        this.currentDisplayTime += milliSec
        while (this.currentDisplayTime > this.tileDisplayDuration) {
          this.currentDisplayTime -= this.tileDisplayDuration
          this.currentTile--

          var currentColumn = this.currentTile % this.tilesHorizontal
          texture.offset.x = currentColumn / this.tilesHorizontal
          var currentRow = Math.floor(this.currentTile / this.tilesHorizontal)

          texture.offset.y = currentRow / this.tilesVertical
          if (this.currentTile === 1) { this.currentTile = 25 }
        }
      }
    },
    TextureAnimator01(texture, tilesHoriz, tilesVert, numTiles, tileDispDuration) {
      // note: texture passed by reference, will be updated by the update function.

      this.tilesHorizontal = tilesHoriz
      this.tilesVertical = tilesVert
      // how many images does this spritesheet contain?
      //  usually equals tilesHoriz * tilesVert, but not necessarily,
      //  if there at blank tiles at the bottom of the spritesheet.
      this.numberOfTiles = numTiles
      texture.wrapS = texture.wrapT = THREE.RepeatWrapping
      texture.repeat.set(1 / this.tilesHorizontal, 1 / this.tilesVertical)

      // how long should each image be displayed?
      this.tileDisplayDuration = tileDispDuration

      // how long has the current image been displayed?
      this.currentDisplayTime = 0

      // which image is currently being displayed?
      this.currentTile = 0

      this.update = function(milliSec) {
        this.currentDisplayTime += milliSec
        while (this.currentDisplayTime > this.tileDisplayDuration) {
          this.currentDisplayTime -= this.tileDisplayDuration
          this.currentTile++

          var currentColumn = this.currentTile % this.tilesHorizontal
          texture.offset.x = currentColumn / this.tilesHorizontal
          var currentRow = Math.floor(this.currentTile / this.tilesHorizontal)
          texture.offset.y = currentRow / this.tilesVertical
          if (this.currentTile === this.numberOfTiles) { this.currentTile = 0 }
        }
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onresize, false)
    cancelAnimationFrame(this.rafId)
    this.renderer.dispose()
    this.renderer.forceContextLoss()
    // this.renderer.context = null
    this.renderer.domElement = null
    this.renderer = null
    this.scene = null
    this.camera = null
    this.rafId = null
    this.container = null
    this.mesh = null
    this.controls = null
    this.modelInfo = null
  }
}
</script>
<style scoped>
  .webglContainer{
    width: 100%;
    height: 100%;
    position: relative;
    background-color:#ffffff;
  }
  #webgl{
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .exitVrBtn{
    width: 100px;
    height: 30px;
    position: absolute;
    left: 50%;
    margin-left: -50px;
    line-height:30px;
    font-size: 12px;
    text-align: center;
    color: #fff;
    background-color: rgba(0,0,0,0.5);
    border-radius: 2px 2px;
  }
  .rightBtns{
    width:31px;
    height:auto;
    position: absolute;
    right:14px;
    top:14px;
  }
  .rightBtns .btns{
    position:relative;
  }
  .rightBtns .btn{
    width:31px;
    height:31px;
    position:relative;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .rightBtns .btn i{
    display: block;
    width:62px;
    height:62px;
    background-image: url("../../public/images/btnBg.png");
    transform-origin: 0 0;
    transform: scale(0.5);
  }
  .rightBtns .btn.vrBtn i{
    background-size: 900px 1009px;
    background-position: 0px -590px;
  }
  .rightBtns .btn.viewChangeBtn i{
    background-size: 900px 1009px;
    background-position: -325px -660px;
  }
  .leftBottomBar{
    width: auto;
    height: auto;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .leftBottomBar .btns{
    position: relative;
    display: flex;
    -webkit-box-direction: normal;
    -webkit-box-orient: horizontal;
    -ms-flex-flow: row nowrap;
    flex-flow: row nowrap;
    height: 48px;
    background-image: linear-gradient(to bottom, rgba(0,0,0,0.1), rgba(0,0,0,0.5));
  }
  .leftBottomBar .btns .btn{
    display: -webkit-box;
    display: -ms-flexbox;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 48px;
    flex: 0 0 48px;
    position: relative;
    cursor: pointer;
  }
  .leftBottomBar .btns .btn img{
    width: 48px;
    height: 48px;
    opacity: 0.3;
  }
  .leftBottomBar .btns .btn.active img{
    opacity: 1.0;
  }
  .thumbPicWrap{
    width: 100%;
    height: 100px;
    position: absolute;
    bottom: 48px;
    background-color: rgba(0,0,0,0.5);
    text-align: center;
  }
  .thumbPicWrap .scrollWrap {
    position: relative;
    width: calc(100vw - 0px);
    height:auto;
    height:100px;
  }
  .thumbPicWrap .thumbPicList{
    height:100px;
    margin-top:10px;
    position: relative;
    display: flex;
    -webkit-box-direction: normal;
    -webkit-box-orient: horizontal;
    -ms-flex-flow: row nowrap;
    flex-flow: row nowrap;
  }
  .thumbPicWrap .thumbPicList div{
    display: -webkit-box;
    display: -ms-flexbox;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 80px;
    flex: 0 0 80px;
    position: relative;
    cursor: pointer;
    margin-left: 5px;
    margin-right: 5px;
    height:80px;
  }
  .thumbPicWrap .thumbPicList div span{
    display: inline-block;
    width: 74px;
    height: 16px;
    text-align: center;
    background-color: rgba(0,0,0,0.5);
    color:white;
    position: absolute;
    left: 3px;
    bottom: 3px;
    font-size: 12px;
    line-height: 16px;
  }
  .thumbPicWrap .thumbPicList img{
    height:80px;
    border-width: 3px;
    border-style: solid;
    border-color: #fff;
    box-sizing: border-box;
  }

  .thumbPicWrap .thumbPicList div.active img{
    border-color: #f6b64c;
  }
</style>
